



















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { randKey } from '@/utils/random'
import Button from './Button.vue'
import { Button as IButton, ButtonGroup as IButtonGroup } from '.'

@Component({
  components: { Button }
})
export default class ButtonGroup extends Vue {
  @Prop({ type: Object, required: true }) preset!: IButtonGroup
  buttons: IButton[] = []
  randKey = randKey()

  @Watch('preset', { immediate: true })
  handlePresetChange() {
    this.buttons = this.preset.group.map(a => ({
      ...a,
      name: 'button',
      text: a.text,
      size: this.preset.size
    }))
  }

  handleClick(event: string) {
    this.$emit('click', event)
  }
}
